<div class="container" *ngIf="loaded && this.activeRecords.length">
  <div class="container__header">
    <h2 tabindex="0">{{'swiper.user.titles' | translateByCustomerType:customerType.dbValue}}</h2>
  </div>

  <opac-swiper [configuration]="swiperConfig" [gradient]="true">
    <opac-swiper-item *ngFor="let activeRecord of activeRecords">
      <app-card-item
        [class.no-details]="!activeRecord.detailsLeft || activeRecord?.detailsLeft.length === 0"
        [baseData]="activeRecord?.baseData"
        [percentage]="activeRecord?.progress"
        [detailsLeft]="activeRecord?.detailsLeft"
        [dominantColors]="activeRecord?.dominantColors"
        [issueDate]="activeRecord.issueDate"
        (actionNavigate)="navToInfo(activeRecord)">
        <ng-template appButtonPanel>
          <app-rating
            class="interactions__rating"
            [mean]="activeRecord?.meanRating"
            [record]="activeRecord"
            [userRating]="activeRecord?.userRating"
            [recordId]="activeRecord?.recordId">
          </app-rating>
          <app-favorite-button [recordId]="activeRecord?.recordId"> </app-favorite-button>

          <app-swiper-more-button [record]="activeRecord?.record"></app-swiper-more-button>
        </ng-template>
        <ng-template appRecordButtons>
          <div class="buttons-wrapper">
            <ng-container *ngIf="activeRecord?.checkoutId; else isLearningExp">
              <app-download-button [record]="activeRecord?.record"> </app-download-button>
            </ng-container>
            <ng-template #isLearningExp>
              <app-external-link-button [record]="activeRecord?.record" [from]="USER_SCREEN">
              </app-external-link-button>
            </ng-template>
          </div>
        </ng-template>
      </app-card-item>
    </opac-swiper-item>

    <opac-swiper-item *ngIf="canMakeCheckouts">
      <active-records-cta (ctaSkeleton)="exploreFullCatalog()"></active-records-cta>
    </opac-swiper-item>
  </opac-swiper>
</div>

<div class="container" *ngIf="!loaded">
  <opac-skeleton class="container__header" style="width: 249px; height: 20px"></opac-skeleton>
  <opac-swiper [configuration]="swiperConfig">
    <opac-swiper-item *ngFor="let i of [1, 2, 3, 4]">
      <active-records-skeleton></active-records-skeleton>
    </opac-swiper-item>
  </opac-swiper>
</div>
